import { Tag } from "antd";
import React from "react";
import RatedWork from "../../../components/Cards/TaskCard";

import { WorkContent } from "./style";

const Works = ({ data, objectsList }) => {
  return (
    <WorkContent>
      <RatedWork data={data} medium objectsList={objectsList} />
    </WorkContent>
  );
};

export default React.memo(Works);
